import {message} from "antd";

export const error_manager = (msg, error) => {
	console.error("Error: ", error);
	message.error(msg, 5);
}
